var map = {
	"./br/PT/S1/bg_p119.jpg": 21972,
	"./br/PT/bg_p119.jpg": 48219,
	"./in/EN/S1/bg_p119.jpg": 47430,
	"./ph/EN/S1/bg_p119.jpg": 88573,
	"./ph/EN/bg_p119.jpg": 89626,
	"./vn/VI/S1/bg_p119.jpg": 2733
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 146;